import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 34BDA78C-9BF6-441A-9924-E8619719C333
 * name plus-minus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-minus.svg
 * tags
 * - Math 
 */
export const PlusMinusIcon = createSvgIcon(<><path d="M11,4V9H6V11H11V16H13V11H18V9H13V4H11M6,18V20H18V18H6Z" /></>, 'PlusMinusIcon');
export default PlusMinusIcon